const WhyChooseData = [
    {
        id: 1,
        img: 'assets/img/whychoose/Harsoft_experience.png',
        title: 'Experience',
        subtitle: 'With over 20 years of collective experience, our team has the knowledge, skills, and expertise to deliver exceptional results that exceed expectations.',
        category: 'coaching',
    },
    {
        id: 2,
        img: 'assets/img/whychoose/Harsoft_Innovation.jpg',
        title: 'Innovation',
        subtitle: 'We stay ahead of the curve by embracing the latest technologies and trends, allowing us to deliver innovative solutions that drive business growth and success.',
        category: 'facilitation',
    },
    {
        id: 3,
        img: 'assets/img/whychoose/harsoft_collaboration.png',
        title: 'Collaboration',
        subtitle: 'We believe in building strong, collaborative partnerships with our clients, working closely with them every step of the way to ensure that their needs and objectives are met.',
        category: 'coaching',
    },
    // {
    //     id:4,
    //     img:'assets/img/whychoose/harsoft_results.jpg',
    //     title:'Results',
    //     subtitle:'Our goal is to create designs that not only look great but also drive results. Whether you are looking to increase brand awareness, generate leads, or boost sales, our graphic design services are designed to help you achieve your objectives.',
    //     category: 'consulting',
    // }
]

export default WhyChooseData;